export const PERF_MARK_PREFIX = 'rl-perf:';
const EVENT_NAME = `${PERF_MARK_PREFIX}app-event`;
let markSeq = 0;
/**
 * Marks the start of a measurement and returns a function to close it.
 * The returned function can be called once with any extra traits;
 * it emits a `rl-perf:custom-event` measure with `label` and those
 * traits as detail attributes picked up by RoutePerformanceObserver.
 *
 * Usage:
 *   const end = startMeasure('my-label');
 *   // ... work happens ...
 *   end({ userId: '123', page: '/projects' });
 */ export const startPerfMeasure = (label)=>{
    markSeq += 1;
    const markId = `${PERF_MARK_PREFIX}start:${markSeq}`;
    performance.mark(markId);
    const end = (traits = {})=>{
        try {
            performance.measure(EVENT_NAME, {
                start: markId,
                detail: {
                    label,
                    ...traits
                }
            });
        } catch (unused) {
        // start mark may have been cleared before end was called
        } finally{
            performance.clearMarks(markId);
        }
    };
    const clear = ()=>{
        performance.clearMarks(markId);
    };
    return [
        end,
        clear
    ];
};
